module.exports = new __parcel__URL__("owl.13d3c4d9.svg").toString();